import { bulkPayout } from '@api/payout';
import { formatErrorMessage } from '@basqet-dashboard/common/utils';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { PayoutErrorView, PayoutLoadingView } from '../../process-payout';
import { PayoutSuccessView } from './success-view';

const ProcessPayout = ({ setCurrentStage, transactionInfo }) => {
  const [payoutState, setPayoutState] = useState('LOADING');
  const [message, setMessage] = useState(`Your money is on it's way.`);

  const PayoutView = payoutStates[payoutState];

  useEffect(() => {
    const processBulkPayout = async () => {
      const { label, otp } = transactionInfo;
      try {
        await bulkPayout({ label, otp });
        setPayoutState('SUCCESS');
      } catch (error) {
        formatErrorMessage(error);
        if (error.response.data.message.includes('code')) {
          await delete transactionInfo.otp;
          setCurrentStage('TWOFA_AUTHENTICATION');
        }
        setPayoutState('ERROR');
      } finally {
        setMessage('');
      }
    };

    processBulkPayout();
  }, []);
  return <PayoutView transactionDetails={transactionInfo} message={message} />;
};
const payoutStates = {
  LOADING: PayoutLoadingView,
  ERROR: PayoutErrorView,
  SUCCESS: PayoutSuccessView
};

ProcessPayout.propTypes = {
  setCurrentStage: PropTypes.func,
  transactionInfo: PropTypes.object
};

export { ProcessPayout };
